import React, { useEffect, useState } from "react";
import { Form, InputGroup } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { ThreeDots } from "react-loader-spinner";
import ErrorLabel from "../../Components/ErrorLabel/ErrorLabel";
import logo from "../../assets/shoplocal logo.svg";
import communityXlogo from "../../assets/communityXlogo.svg";
import subHeadingImage from "../../assets/business profile logo.svg";
import regnerateIcon from "../../assets/regenerate icon.svg";
import copyIcon from "../../assets/copy icon.svg";
import { userId } from "../../Utils/LocalStorage";
import { VoucherAIResApi } from "../../Utils/Api/VoucherAIResApi";
import { toast } from "react-toastify";
import MultiSelectDropdown from "../../Components/MultiSelectDropdown/MultiSelectDropdown";
import SelectDropdown from "../../Components/SelectDropdown/SelectDropdown";
import Loader from "../../Components/Loader/Loader";

const ShopLocalVoucher = () => {
  // form data initial values
  const [formData, setFormData] = useState({
    retailPrice: "",
    voucherPrice: "",
    campaignType: "",
    holiday: "",
    customerType: [],
    sentimentType: [],
  });
  const campaignOptions = [
    { name: "New Year Sale", id: 1 },
    { name: "Spring", id: 2 },
    { name: "Summer", id: 3 },
    { name: "Fall", id: 4 },
    { name: "New Service", id: 5 },
    { name: "New Product", id: 6 },
    { name: "Holiday Sale", id: 7 },
    { name: "Year End Sales", id: 8 },
  ];
  const holidayOptions = [
    { name: "New Year", id: 1 },
    { name: "Valentine's Day", id: 2 },
    { name: "Spring Break", id: 3 },
    { name: "Labor Day", id: 4 },
    { name: "Mother's Day", id: 5 },
    { name: "Father's Day", id: 6 },
    { name: "4th of July", id: 7 },
    { name: "Memorial Day", id: 8 },
    { name: "Thanksgiving", id: 9 },
    { name: "Halloween", id: 10 },
    { name: "Christmas", id: 11 },
  ];
  const customerOptions = [
    { name: "Male", id: 1 },
    { name: "Female", id: 2 },
    { name: "Adult", id: 3 },
    { name: "Child", id: 4 },
    { name: "Business", id: 5 },
  ];
  const sentimentOptions = [
    { name: "Excitement", id: 1 },
    { name: "Value", id: 2 },
    { name: "Exclusive", id: 3 },
    { name: "Luxury", id: 4 },
    { name: "Joy", id: 5 },
    { name: "Adventure", id: 6 },
    { name: "Personalized", id: 7 },
    { name: "Celebration", id: 8 },
    { name: "Gratitude", id: 9 },
    { name: "Rewarding", id: 10 },
  ];

  const [voucherTitleInput, setVoucherTitleInput] = useState("");

  // form data error values
  const [errorLabelName, setErrorLabelName] = useState({
    retailPrice: "",
    voucherPrice: "",
    campaignType: "",
    holiday: "",
    customerType: "",
    sentimentType: "",
  });

  // state to show response section
  const [descriptionIsCheck, setDescriptionIsCheck] = useState(false);
  const [titleIsCheck, setTitleIsCheck] = useState(false);

  // state to toggle between loading lines in button
  const [descriptionRotatorLine, setDescriptionRotatorLine] = useState(false);
  const [titleRotatorLine, setTitleRotatorLine] = useState(false);

  // state to show response generated
  const [descriptionResponseGenerated, setDescriptionResponseGenerated] =
    useState("");
  const [titleResponseGenerated, settitleResponseGenerated] = useState();

  // state to copy the response in the clipboard
  const [descriptionCopyTextField, setDescriptionCopyTextField] =
    useState(false);
  const [titleCopyTextField, setTitleCopyTextField] = useState(false);

  const navigate = useNavigate();
  const uid = parseInt(userId());
  const [loading, setLoading] = useState(false);

  ////////////// response generator function //////////////
  const responseGenerator = async (flag) => {
    if (
      formData.retailPrice &&
      formData.voucherPrice &&
      formData.campaignType &&
      formData.holiday &&
      formData.customerType.length > 0 &&
      formData.sentimentType.length > 0 &&
      (flag === "title" || (flag === "description" && voucherTitleInput !== ""))
    ) {
      const data = {
        business_id: uid ? uid : "",
        response_for: flag === "description" ? "description" : "title",
        retailPrice: formData.retailPrice ? parseInt(formData.retailPrice) : 0,
        voucherPrice: formData.voucherPrice
          ? parseInt(formData.voucherPrice)
          : 0,
        campaignType: formData.campaignType ? formData.campaignType : "",
        holiday: formData.holiday ? formData.holiday : "",
        customerType: formData.customerType ? formData.customerType : "",
        sentimentType: formData.sentimentType ? formData.sentimentType : "",
        voucherTitle: voucherTitleInput ? voucherTitleInput : "",
      };

      if (flag === "description" && titleRotatorLine === false) {
        setDescriptionRotatorLine(true);
      } else if (flag === "title" && descriptionRotatorLine === false) {
        setTitleRotatorLine(true);
      }

      const VoucherAIRes = await VoucherAIResApi(data, () => {
        navigate("/");
      });
      if (VoucherAIRes.success === true) {
        if (flag === "title") {
          settitleResponseGenerated(VoucherAIRes.data);
          setTitleIsCheck(true);
          setTitleRotatorLine(false);
        } else if (flag === "description") {
          setDescriptionResponseGenerated(VoucherAIRes.data);
          setDescriptionIsCheck(true);
          setDescriptionRotatorLine(false);
        }
      }else if (VoucherAIRes.status === 429) {
        setLoading(true);
        toast.error(VoucherAIRes.message, {
          position: "top-center",
          width: "500px",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      } else {
        toast.error("Internal Server Error", {
          position: "top-center",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        setDescriptionIsCheck(false);
        setTitleIsCheck(false);
        setTitleRotatorLine(false);
        setDescriptionRotatorLine(false);
      }
    }
    setErrorLabelName((prevState) => ({
      ...prevState,
      retailPrice:
        formData.retailPrice === "" ? "Please input retail price" : "",
      voucherPrice:
        formData.voucherPrice === "" ? "Please input voucher price" : "",
      holiday: formData.holiday === "" ? "Please select a holiday" : "",
      campaignType:
        formData.campaignType === "" ? "Please select a campaign type" : "",
      customerType:
        formData.customerType.length === 0
          ? "Please select a customer type"
          : "",
      sentimentType:
        formData.sentimentType.length === 0
          ? "Please select a sentiment type"
          : "",
      titleName:
        flag === "description" && voucherTitleInput === ""
          ? "Please input your title"
          : "",
    }));
  };

  ////////////// function for selection and removal of dropdown items //////////////
  const handleInputChange = (selectedValue, flag) => {
    if (flag === "campaign_Type") {
      setFormData((prevFormData) => ({
        ...prevFormData,
        campaignType: selectedValue,
      }));
    } else if (flag === "holiday_Type") {
      setFormData((prevFormData) => ({
        ...prevFormData,
        holiday: selectedValue,
      }));
    } else if (flag === "sentiment_Type") {
      setFormData((prevFormData) => ({
        ...prevFormData,
        sentimentType: selectedValue,
      }));
    } else if (flag === "customer_Type") {
      setFormData((prevFormData) => ({
        ...prevFormData,
        customerType: selectedValue,
      }));
    }
  };

  ////////////// validation for field inputs //////////////
  const handleChange = (e, flag) => {
    // setDescriptionIsCheck(false)
    // setTitleIsCheck(false)
    if (flag === "retail_price") {
      setFormData((ps) => {
        const inputValue = e.target.value;
        const sanitizedValue = inputValue.replace(/[^0-9.]/g, "");
        const truncatedValue = sanitizedValue.slice(0, 6);
        const validNumber = truncatedValue.replace(/(\..*?)\..*/g, "$1");
        let finalNumber;
        if (validNumber.includes(".")) {
          const [integerPart, decimalPart] = validNumber.split(".");
          const truncatedDecimalPart = decimalPart.slice(0, 2);
          finalNumber = `${integerPart}.${truncatedDecimalPart}`;
        } else {
          finalNumber = validNumber;
        }
        return {
          ...ps,
          retailPrice: finalNumber,
        };
      });
    } else if (flag === "voucher_price") {
      setFormData((ps) => {
        const inputValue = e.target.value;
        const sanitizedValue = inputValue.replace(/[^0-9.]/g, "");
        const truncatedValue = sanitizedValue.slice(0, 6);
        const validNumber = truncatedValue.replace(/(\..*?)\..*/g, "$1");
        let finalNumber;
        if (validNumber.includes(".")) {
          const [integerPart, decimalPart] = validNumber.split(".");
          const truncatedDecimalPart = decimalPart.slice(0, 2);
          finalNumber = `${integerPart}.${truncatedDecimalPart}`;
        } else {
          finalNumber = validNumber;
        }
        return {
          ...ps,
          voucherPrice: finalNumber,
        };
      });
    }
  };

  ////////////// function to copy the response //////////////
  const titleCopyText = () => {
    const paragraphElement = document.getElementById(
      "title-response-generated"
    );
    if (paragraphElement) {
      const textToCopy = paragraphElement.innerText;
      navigator.clipboard.writeText(textToCopy);
      setTitleCopyTextField(true);
      setTimeout(() => {
        setTitleCopyTextField(false);
      }, 2000);
    }
  };
  const descriptionCopyText = () => {
    const paragraphElement = document.getElementById(
      "description-response-generated"
    );
    if (paragraphElement) {
      const textToCopy = paragraphElement.innerText;
      navigator.clipboard.writeText(textToCopy);
      setDescriptionCopyTextField(true);
      setTimeout(() => {
        setDescriptionCopyTextField(false);
      }, 2000);
    }
  };

  ////////////// function to scroll down to the response once generated //////////////
  useEffect(() => {
    const copyButton = document.getElementById("copy-button");
    if (copyButton) {
      const buttonPosition =
        copyButton.getBoundingClientRect().top + window.scrollY;
      window.scrollTo(0, buttonPosition);
    }
  }, [descriptionResponseGenerated, titleResponseGenerated]);

  return (
    <>
    {loading === true ? <Loader /> : ""}
    <div className="shoplocalai-content-wrapper">
      <div className="shoplocalai-section-one">
        <img src={communityXlogo} alt="CommunityX Digital" className="shop-local-logo" style={{width:200}}/>
        <h2>
          <img
            src={subHeadingImage}
            alt="Subheading Image"
            className="subHeadingImage"
          />
          I WANT TO CREATE A NEW VOUCHER TITLE AND DESCRIPTION
        </h2>
        <p className="bussiness-p_S text-center mt-1">
          When you are creating a new voucher, use this AI tool to create
          Voucher Title and Voucher description that will be attractive, SEO
          optimized and impactful.
        </p>
        <p className="mt-1 bussiness-p_S mb-2">
          <b className="bold_bussiness_S">First Step:</b> Create the Voucher
          Title. Select the option below and click on “Generate Voucher Title”.
          You will be presented with 3 title options.
          <br />
          <b className="bold_bussiness_S">Second Step:</b> Copy the one that is
          closest to what you need, paste it in the field below the “Generate
          Voucher Description”, if you would like to edit the content, edit it
          and click on “Generate Voucher Description”. <br />
          <b className="bold_bussiness_S">Please note:</b> Use this tool as a
          start to create content. Copy the content generated, modify it as
          needed and use it in your voucher creation. Sometimes the AI generated
          content may not be perfect to your needs, please review the
          information carefully.
        </p>
      </div>
      <div className="shoplocalai-section-two">
        <Form.Group className="mb-3" controlId="formBasicEmail">
          <Form.Label className="form-label-custom">
            Retail price<span className="star-required">* </span>
          </Form.Label>
          <InputGroup className="edit-border">
            <Form.Control
              type="text"
              placeholder="Enter a number"
              className="custom-formcontrol"
              name="retail_price"
              value={formData.retailPrice}
              onChange={(e) => handleChange(e, "retail_price")}
              autoComplete="off"
            />
          </InputGroup>
          <ErrorLabel ErrorDisplay={errorLabelName.retailPrice} />
        </Form.Group>
        <Form.Group className="mb-3" controlId="formBasicEmail">
          <Form.Label className="form-label-custom">
            Voucher price<span className="star-required">* </span>
          </Form.Label>
          <InputGroup className="edit-border">
            <Form.Control
              type="text"
              placeholder="Enter a number"
              className="custom-formcontrol"
              name="voucher_price"
              value={formData.voucherPrice}
              onChange={(e) => handleChange(e, "voucher_price")}
              autoComplete="off"
            />
          </InputGroup>
          <ErrorLabel ErrorDisplay={errorLabelName.voucherPrice} />
        </Form.Group>
        <Form.Group className="mb-3" controlId="formBasicEmail">
          <Form.Label className="form-label-custom">
            Campaign Type<span className="star-required">* </span>
          </Form.Label>
          <InputGroup
            title={
              formData.campaignType
                ? formData.campaignType
                : "Select a campaign that is most relevant."
            }
          >
            <Form.Group className="mb-0" controlId="formBasicEmail">
              <SelectDropdown
                placeHolder="Select a campaign that is most relevant."
                options={campaignOptions}
                inputValue={(selectedValue) => {
                  handleInputChange(selectedValue, "campaign_Type");
                }}
              />
            </Form.Group>
          </InputGroup>
          <ErrorLabel ErrorDisplay={errorLabelName.campaignType} />
        </Form.Group>
        <Form.Group className="mb-3" controlId="formBasicEmail">
          <Form.Label className="form-label-custom">
            Holiday<span className="star-required">* </span>
          </Form.Label>
          <InputGroup
            title={formData.holiday ? formData.holiday : "Select one option"}
          >
            <Form.Group className="mb-0" controlId="formBasicEmail">
              <SelectDropdown
                placeHolder="Select one option"
                options={holidayOptions}
                inputValue={(selectedValue) => {
                  handleInputChange(selectedValue, "holiday_Type");
                }}
              />
            </Form.Group>
          </InputGroup>
          <ErrorLabel ErrorDisplay={errorLabelName.holiday} />
        </Form.Group>
        <Form.Group className="mb-3" controlId="formBasicEmail">
          <Form.Label>
            Customer Type<span className="star-required">* </span>
          </Form.Label>
          <InputGroup
            title={
              formData.customerType.length > 0
                ? formData.customerType
                : "Select all that apply"
            }
          >
            <Form.Group className="mb-0" controlId="formBasicEmail">
              <MultiSelectDropdown
                placeholder="Select all that apply"
                options={customerOptions}
                inputValue={(selectedValue) => {
                  handleInputChange(selectedValue, "customer_Type");
                }}
              />
            </Form.Group>
          </InputGroup>
          <ErrorLabel ErrorDisplay={errorLabelName.customerType} />
        </Form.Group>
        <Form.Group className="mb-3" controlId="formBasicEmail">
          <Form.Label className="form-label-custom">
            Sentiment<span className="star-required">* </span>
          </Form.Label>
          <InputGroup
            title={
              formData.sentimentType.length > 0
                ? formData.sentimentType
                : "Select up to 3 sentiments"
            }
          >
            <Form.Group className="mb-0" controlId="formBasicEmail">
              <MultiSelectDropdown
                maxOptions="3"
                placeholder="Select up to 3 sentiments"
                options={sentimentOptions}
                inputValue={(selectedValue) => {
                  handleInputChange(selectedValue, "sentiment_Type");
                }}
              />
            </Form.Group>
          </InputGroup>
          <ErrorLabel ErrorDisplay={errorLabelName.sentimentType} />
        </Form.Group>
      </div>
      <div className="generator-div-wrapper vou-cou-ai-container">
        <div className="button-div title-button-wrapper">
          {titleRotatorLine ? (
            <button className="generate-response-button loader-button">
              <ThreeDots
                style={{ position: "absolute" }}
                height="10"
                width="30"
                radius="9"
                color="white"
                ariaLabel="three-dots-loading"
                wrapperStyle={{}}
                wrapperClassName=""
                visible={true}
              />
            </button>
          ) : titleIsCheck ? (
            <button
              className="regenerate-button"
              onClick={() => responseGenerator("title")}
            >
              <img
                loading="lazy"
                src={regnerateIcon}
                className="regnerateIcon"
                alt="Regnerate Icon"
              />
              Regenerate Voucher Title
            </button>
          ) : (
            <button
              className="generate-response-button"
              onClick={() => responseGenerator("title")}
            >
              Generate Voucher Title
            </button>
          )}
          <p className="toggling-content vou-cou-toggling-content">
            (To avoid losing access, please copy the generated content before
            leaving the tab.)
          </p>
          {titleIsCheck ? (
            <div className="response-section">
              <p
                id="title-response-generated"
                dangerouslySetInnerHTML={{ __html: titleResponseGenerated }}
              />
              {titleResponseGenerated ? (
                <button onClick={titleCopyText} id="copy-button">
                  {titleCopyTextField ? (
                    "Copied!"
                  ) : (
                    <>
                      <img
                        loading="lazy"
                        src={copyIcon}
                        alt="Copy Icon"
                        className="copyIcon"
                      />
                      Copy
                    </>
                  )}
                </button>
              ) : (
                <></>
              )}
            </div>
          ) : (
            <></>
          )}
        </div>
        <div className="button-div description-button-wrapper">
          {descriptionRotatorLine ? (
            <button className="generate-response-button loader-button">
              <ThreeDots
                style={{ position: "absolute" }}
                height="10"
                width="30"
                radius="9"
                color="white"
                ariaLabel="three-dots-loading"
                wrapperStyle={{}}
                wrapperClassName=""
                visible={true}
              />
            </button>
          ) : descriptionIsCheck ? (
            <button
              className="regenerate-button"
              onClick={() => responseGenerator("description")}
            >
              <img
                loading="lazy"
                src={regnerateIcon}
                className="regnerateIcon"
                alt="Regnerate Icon"
              />
              Regenerate Voucher Description
            </button>
          ) : (
            <button
              className="generate-response-button"
              onClick={() => responseGenerator("description")}
            >
              Generate Voucher Description
            </button>
          )}
          <Form.Control
            type="text"
            placeholder="Type / paste your title here"
            className="custom-formcontrol title-input-field"
            name="title input"
            value={voucherTitleInput}
            onChange={(e) => {
              setVoucherTitleInput(e.target.value);
            }}
            autoComplete="off"
          />
          {!voucherTitleInput ? (
            <p className="ai-error">{errorLabelName.titleName}</p>
          ) : (
            <></>
          )}
          {descriptionIsCheck ? (
            <div className="response-section">
              <p
                id="description-response-generated"
                dangerouslySetInnerHTML={{
                  __html: descriptionResponseGenerated,
                }}
              />
              {descriptionResponseGenerated ? (
                <button onClick={descriptionCopyText} id="copy-button">
                  {descriptionCopyTextField ? (
                    "Copied!"
                  ) : (
                    <>
                      <img
                        loading="lazy"
                        src={copyIcon}
                        alt="Copy Icon"
                        className="copyIcon"
                      />
                      Copy
                    </>
                  )}
                </button>
              ) : (
                <></>
              )}
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
    </>
  );
};

export default ShopLocalVoucher;
